import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface OffTagIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const OffTagIcon = ({ className, ...props }: OffTagIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 15V9C1 5.68629 3.68629 3 7 3H17C20.3137 3 23 5.68629 23 9V15C23 18.3137 20.3137 21 17 21H7C3.68629 21 1 18.3137 1 15Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M12 12H14.25M15 9H12V15"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M17 12H19.25M20 9H17V15"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M7 9C8.65685 9 10 10.3431 10 12C10 13.6569 8.65685 15 7 15C5.34315 15 4 13.6569 4 12C4 10.3431 5.34315 9 7 9Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export default OffTagIcon;
